// frontend/src/core/api/london.js

// London-region endpoints. Owned by LondonAdapter.
import { apiFetch } from './client';

export const fetchLines = () =>
  apiFetch('/api/london/lines');

export const fetchPjf = () =>
  apiFetch('/api/london/pjf');

export const fetchRouteStops = (contractLineNo) =>
  apiFetch(`/api/london/stops?contract_line_no=${encodeURIComponent(contractLineNo)}`);

export const fetchLiveBuses = (contractLineNo) =>
  apiFetch(`/api/london/livebus?contract_line_no=${encodeURIComponent(contractLineNo)}`);

export const fetchArrivals = (contractLineNo, naptanId = null) => {
  let path = `/api/london/arrival?contract_line_no=${encodeURIComponent(contractLineNo)}`;
  if (naptanId) path += `&naptan_id=${encodeURIComponent(naptanId)}`;
  return apiFetch(path);
};

export const fetchExpectedArrivals = (contractLineNo) =>
  apiFetch(`/api/london/expected?contract_line_no=${encodeURIComponent(contractLineNo)}`);

export const fetchSchedule = (contractLineNo, date, naptanId = null) => {
  let path = `/api/london/schedule?contract_line_no=${encodeURIComponent(contractLineNo)}&calender_date=${encodeURIComponent(date)}`;
  if (naptanId) path += `&naptan_id=${encodeURIComponent(naptanId)}`;
  return apiFetch(path);
};

// Scheduled stop ladder of the trip that follows `tripNoLbsl` inside the same
// driver run. Resolves to `{ next_trip: null }` when there is no
// opposite-direction trip to show, so callers must tolerate a null payload.
export const fetchNextTrip = (contractLineNo, date, tripNoLbsl, runningNo = null) => {
  let path = `/api/london/nexttrip?contract_line_no=${encodeURIComponent(contractLineNo)}&calender_date=${encodeURIComponent(date)}&trip_no_lbsl=${encodeURIComponent(tripNoLbsl)}`;
  if (runningNo !== null && String(runningNo).trim() !== '') {
    path += `&running_no=${encodeURIComponent(runningNo)}`;
  }
  return apiFetch(path);
};

export const fetchHeadway = (contractLineNo) =>
  apiFetch(`/api/london/headway?contract_line_no=${encodeURIComponent(contractLineNo)}`);

export const fetchHourMetrics = (contractLineNo) =>
  apiFetch(`/api/london/hourmetric?contract_line_no=${encodeURIComponent(contractLineNo)}`);

export const fetchStopMetrics = (contractLineNo) =>
  apiFetch(`/api/london/stopmetric?contract_line_no=${encodeURIComponent(contractLineNo)}`);